import React, { useCallback } from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { setInitialCartState } from '@yme/common/redux/cart/actions';
import { COOKIE_CART_ID_KEY } from '@yme/common/redux/cart/constants';
import { getCartCounter } from '@yme/common/redux/cart/selectors';
import { getRootPath } from '@yme/components/CheckoutForm/PaymentSteps/selectors';
import { CheckoutSteps } from '@yme/components/CheckoutForm/constants';
import { getOrderReviewState } from '@yme/components/CheckoutForm/redux/selectors';
import { ICON_MAP } from '@yme/modals/GeneralMessageModal/constants';
import { setIsModalHide } from '@yme/modals/actions';
import { getModalData } from '@yme/modals/selectors';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { Status } from '@yme/utils/constants';
import { setOrderReviewStatus } from '../../redux/actions';
import { IconWrapper } from './styled';
export function ReviewModal() {
    const isRightToLeft = useSelector(getRTL);
    const { state, title, description, primaryButtonContent, secondaryButtonContent } = useSelector(getModalData);
    const dispatch = useDispatch();
    const { status } = useSelector(getOrderReviewState);
    const languageRootPath = useSelector(getRootPath);
    const cartCounter = useSelector(getCartCounter);
    const handleHideModal = useCallback(() => {
        if (status === Status.EXPIRED_STATUS) {
            Cookies.remove(COOKIE_CART_ID_KEY, {
                path: `${languageRootPath}/`,
            });
            dispatch(setInitialCartState());
            window.location.hash = `#${CheckoutSteps.CART}`;
        }
        if (status === Status.CHANGE_STOCK && cartCounter === 0) {
            dispatch(setOrderReviewStatus(''));
            window.location.hash = `#${CheckoutSteps.CART}`;
        }
        dispatch(setIsModalHide());
    }, [dispatch, status, languageRootPath, cartCounter]);
    return (React.createElement(StaticModalWindow, { onHide: handleHideModal, minHeight: "auto", staticModalSize: MD_MODAL, title: title, isRightToLeft: isRightToLeft, footerComponent: React.createElement(ModalWindowFooter, { isCancelButton: Boolean(secondaryButtonContent), isSubmitButton: true, submitButtonLabel: primaryButtonContent, cancelButtonLabel: secondaryButtonContent, onSubmit: handleHideModal }) },
        React.createElement(FlexWrapper, { justifyContent: "center", isFullWidth: true, mb: INDENT.sm },
            React.createElement(IconWrapper, { state: state },
                React.createElement(SVGIcon, { type: ICON_MAP[state], size: ICON_SIZE.l }))),
        React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, description)));
}
